/** biome-ignore-all lint/suspicious/noExplicitAny: lsp-ok*/
'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ActionCard } from './ActionCard';
import type { ActionCardProps } from './ActionCard.types';
import { ActionCardLCP } from './ActionCardLCP';
interface ActionCardShellProps extends ActionCardProps {
  isLCP?: boolean;
}
export const ActionCardShell = t0 => {
  const $ = _c(9);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      isLCP: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const isLCP = t1 === undefined ? false : t1;
  const [enhanced, setEnhanced] = useState(!isLCP);
  let t2;
  let t3;
  if ($[3] !== isLCP) {
    t2 = () => {
      if (!isLCP) {
        return;
      }
      let cancelled = false;
      const enhance = () => {
        if (!cancelled) {
          setEnhanced(true);
        }
      };
      if ("scheduler" in window && "postTask" in (window as any).scheduler) {
        (window as any).scheduler.postTask(enhance, {
          priority: "user-visible"
        });
      } else {
        const timeoutId = window.setTimeout(enhance, 300);
        return () => {
          cancelled = true;
          clearTimeout(timeoutId);
        };
      }
      return () => {
        cancelled = true;
      };
    };
    t3 = [isLCP];
    $[3] = isLCP;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== enhanced || $[7] !== props) {
    t4 = <div className="h-full">{enhanced ? <ActionCard {...props} /> : <ActionCardLCP title={props.title} backgroundImage={props.backgroundImage} actionTypeName={props.actionTypeName} celebrity={props.celebrity} tokenReward={props.tokenReward} gemReward={props.gemReward} tokenCost={props.tokenCost} />}</div>;
    $[6] = enhanced;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};